import React, { Component } from 'react';
import './App.css';
import './timeline.css';
import FetchAllApps from './FetchAllApps';
import DisplayApplication from './DisplayApplication.js';
import { IntlProvider } from 'react-intl';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: '',
      selectedDetails: '',
    } 
  }

  selectedCallback = (dataFromChild) => this.setState({selectedItem: dataFromChild});

  render() {
    
    //console.log("App: " + this.selectedDetails);
    //console.log(this.state.selectedItem);
    if(this.state.selectedItem) {
      return (
        <IntlProvider locale="en-au">
        <div className="App">

          <div id = "search">
            <FetchAllApps allAppsCallBackFromParent={this.selectedCallback} />
          </div>
          <div id = "results">
            <DisplayApplication appDetailsID = {this.state.selectedItem} />
          </div>
        </div>
        </IntlProvider>
      );
    } else {
      return (
        <IntlProvider locale="en-au">
        <div className="App">

          <div id = "search">
            <FetchAllApps allAppsCallBackFromParent={this.selectedCallback} />
          </div>
        </div>
        </IntlProvider>
      );
    }
    
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js